import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { styles } from './ProgressBar.css';
import React from 'react';

interface ProgressBarProps {
  currentItemsCount: number;
  totalItemsCount: number;
  shouldShowText?: boolean;
  className?: string;
}

export const ProgressBar = ({
  currentItemsCount,
  totalItemsCount,
  shouldShowText,
  className = '',
}: ProgressBarProps) => {
  const progressPercentage = (currentItemsCount / totalItemsCount) * 100;
  return (
    <>
      {shouldShowText ? (
        <div className={styles.progressBarText}>{`Showing ${currentItemsCount} of ${totalItemsCount}`}</div>
      ) : null}
      <div className={classNames([className, styles.progressBar])}>
        <div className={styles.progressBarFilled} style={{ width: `${progressPercentage}%` }} />
      </div>
    </>
  );
};
